var React = require('react');

function Confirmacao (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M30.2667 16C30.2667 23.8793 23.8793 30.2667 16 30.2667C8.12074 30.2667 1.73333 23.8793 1.73333 16C1.73333 8.12074 8.12074 1.73333 16 1.73333C23.8793 1.73333 30.2667 8.12074 30.2667 16ZM32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16ZM23.4532 11.2841C23.7943 10.8497 23.7186 10.2211 23.2842 9.88006C22.8498 9.53902 22.2212 9.61471 21.8801 10.0491L14.1243 19.9281L9.95196 16.643C9.51803 16.3014 8.8893 16.3762 8.54765 16.8101C8.206 17.244 8.2808 17.8728 8.71473 18.2144L13.6739 22.119C13.8825 22.2832 14.1478 22.3578 14.4113 22.3262C14.6749 22.2947 14.9151 22.1596 15.0791 21.9508L23.4532 11.2841Z"}));
}

Confirmacao.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","className":"icon"};

module.exports = Confirmacao;

Confirmacao.default = Confirmacao;
